import React from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ center, onCenterChange }) => {
  return (
    <Card className={styles.card} title="Adresse du centre" classTitle="title-green">

      <div className={styles.group}>

        <TextInput
          className={styles.field}
          label="Adresse"
          name="address"
          type="text"
          placeholder="Adresse complète"
          value={center?.address || ''}
          onChange={onCenterChange}
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          placeholder="Ex: Appartement, étage..."
          value={center?.address_complement || ''}
          onChange={onCenterChange}
        />
        <TextInput
          className={styles.field}
          label="Code Postal"
          name="zip_code"
          type="text"
          placeholder="Code postal"
          value={center?.zip_code || ''}
          onChange={onCenterChange}
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          placeholder="Ville"
          value={center?.city || ''}
          onChange={onCenterChange}
        />
        <TextInput
          className={styles.field}
          label="Département"
          name="department"
          type="number"
          value={center?.department || ''}
          onChange={onCenterChange}
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          placeholder="Pays"
          value={center?.country || ''}
          onChange={onCenterChange}
        />
      </div>
    </Card >
  );
};

export default AddressInformations;
